import React, { PureComponent, Suspense } from "react";
import PropTypes from "prop-types";
import { Provider as StoreProvider } from "react-redux";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import App from "./App";

class Root extends PureComponent {
  render() {
    const { elementId, store, theme, themeTdsId } = this.props;
    const styleSheetTarget = document.getElementById(elementId);

    return (
      <StoreProvider store={store}>
        <StyleSheetManager target={styleSheetTarget}>
          <ThemeProvider theme={theme}>
            <Suspense fallback={<span />}>
              <App themeTdsId={themeTdsId} />
            </Suspense>
          </ThemeProvider>
        </StyleSheetManager>
      </StoreProvider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default Root;
